import React from "react";
import { 
    TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Paper,
} from '@mui/material';

import * as CONSTANTS from "../../constants"


const ApproveTopicTable = ({lang, stat}) => {


    return (
        <TableContainer component={Paper}>
            <Table sx={{ overflow: 'auto' }} >
                <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">{CONSTANTS.APPROVE_TOPIC.DASHBOARD_STATUS.PENDING[lang]}</TableCell>
                    <TableCell align="right">{CONSTANTS.APPROVE_TOPIC.DASHBOARD_STATUS.APPROVED[lang]}</TableCell>
                    <TableCell align="right">{CONSTANTS.APPROVE_TOPIC.DASHBOARD_STATUS.REJECTED[lang]}</TableCell>
                    <TableCell align="right">{CONSTANTS.APPROVE_TOPIC.DASHBOARD_STATUS.TOTAL[lang]}</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row">{CONSTANTS.DRAWER.WAZAREN[lang]}</TableCell>
                        <TableCell align="right">{stat? stat.wazaren.pending: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wazaren.approved: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wazaren.rejected: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wazaren.pending + stat.wazaren.approved + stat.wazaren.rejected: "---"}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row">{CONSTANTS.DRAWER.WOTAGEISHI[lang]}</TableCell>
                        <TableCell align="right">{stat? stat.wotageishi.pending: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wotageishi.approved: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wotageishi.rejected: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.wotageishi.pending + stat.wotageishi.approved + stat.wotageishi.rejected: "---"}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row">{CONSTANTS.DRAWER.ORGANIZATION[lang]}</TableCell>
                        <TableCell align="right">{stat? stat.organization.pending: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.organization.approved: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.organization.rejected: "---"}</TableCell>
                        <TableCell align="right">{stat? stat.organization.pending + stat.organization.approved + stat.organization.rejected: "---"}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
 
export default ApproveTopicTable;